import { createStyles } from '@material-ui/styles';
import React, { useGlobal } from 'reactn';
import ImportIcon from '@material-ui/icons/ImportExport';
import ExitIcon from '@material-ui/icons/Clear';
import { CompanySearchModel, Company } from '../models/company';
import { Formik, Form, FormikProps, Field } from 'formik';
import ErrorSummaryInModal from '../formik/ErrorSummaryInModal';
import { UamTextField, UamNumberField } from '../formik/UamTextField';
import { Autocomplete, AutocompleteChangeReason } from '@material-ui/lab';
import * as telematicofunctions from '../core/telematico/telematicoFunctions'
import { loadDatiFromTelematicos } from '../services/telematicoService';
import { Dialog, DialogTitle, DialogContent, DialogActions, Fab, Theme, makeStyles, Typography, FormControl, InputLabel, MenuItem, TextField, Button, Select } from '@material-ui/core';
import { LoadTelematico, DefaultInputProps, DialogInputProps } from '../types/types';
import { getAgencies } from '../services/agencyService';
import { LoggerServiceProvider, useLogger } from '../logger';
import { Agency, AgencySearchModel } from '../models/agency';
import { TelematicoServiceValidation } from '../core/telematico/telematicoFunctions';
import { getLevels } from '../types/auth';
import { useEffect } from 'react';
import { IGlobalState } from '../states/GlobalState';
import { globalStyles } from '../style/GlobalStyles';
import { TypeSocieta, TypePersonaFisica } from '../types/constants';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      marginTop: '4px',
      minWidth: 150
    },
    formAutocompleteControl: {
      marginTop: '4px',
      minWidth: 150
    },
    select: {
      width: 200,
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    label: {
      // width: 200,
      marginLeft: theme.spacing(1),
      // marginRight: theme.spacing(1),
    },
    selectLong: {
      width: 416,
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
}),
);

export default function DialogTelematico(props: DialogInputProps) {
  const gClasses = globalStyles();
  const classes = useStyles();
  const[identity,] = useGlobal<IGlobalState, 'identity'>('identity');
  const [auth,] = useGlobal<IGlobalState, 'auth'>('auth')
  const logger = useLogger({key: 'loadTelematico'});
  const formTextFieldMargin = 'dense'
  const[ip,] = useGlobal<IGlobalState, 'ip'>('ip');
  const[companies,] = useGlobal<IGlobalState, 'companies'>('companies');
  const [agencies, setAgencies] = React.useState<Agency[]>([]);
  const adLevels = getLevels(auth.authData);
  const [telematicoService] = React.useState(() => new TelematicoServiceValidation(adLevels))
  const { state, isConvenienza } = props;
  const telematicoFormSchema = isConvenienza ? telematicoService.telematicoConvenienzaFormSchemaBase() : telematicoService.telematicoForfetariFormSchemaBase();

  const loadAgencies = async (value: number) => {
    let model = new AgencySearchModel();
    model.CompanyId = value;
    if (identity?.PrincipalAuth[0] && identity?.PrincipalAuth[0].AgencyId){
        model.Id = identity?.PrincipalAuth[0].AgencyId;
    }
    
    let res = await (await getAgencies(ip, auth.authData!, auth.user!, model));
    setAgencies(res?.ResultList);
  }


  useEffect(() => {
    console.log('Use effect agencies')
    if (identity && identity.CompanyId) {
      loadAgencies(identity.CompanyId);
    }
    console.log('Principal auth length: ' + identity?.PrincipalAuth?.length)
    if (identity && identity.PrincipalAuth[0]) {
      console.log('Principal auth Agency Id: ' + identity?.PrincipalAuth[0].AgencyId)
    }
  }, [])
  
  return (
  <Dialog
    open={props.caricaDatiTelematicoOpen}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    maxWidth="md"
  >
  <DialogTitle id="alert-dialog-title">{<Typography variant="h5" color="primary">Carica dati telematico</Typography>}</DialogTitle>
    <div style={{width: '100%'}}>
      <Formik
        initialValues={{ isConvenienza: isConvenienza, companyId: identity?.CompanyId ? identity.CompanyId : null, 
          agency: identity?.PrincipalAuth[0] ? identity?.PrincipalAuth[0]?.Agency : null, 
          agencyId: identity?.PrincipalAuth[0] ? identity?.PrincipalAuth[0]?.AgencyId : null, 
          telematicoType: isConvenienza ? TypeSocieta : TypePersonaFisica, year: null, cfImpresa: '', yearCf1: null, cfCollab1: '', 
          yearCf2: null, cfCollab2: '', yearS3: null, cfSocio3: '' }}
        validationSchema={telematicoFormSchema}
        validate={values => {
          const errors = {};
          if (isConvenienza) {
            if ((!values.year && values.cfImpresa) || (values.year && !values.cfImpresa)) {
              errors.year = 'Richiesto anno e partita iva impresa';
            } else if((!values.yearCf1 && values.cfCollab1) || (values.yearCf1 && !values.cfCollab1)) {
              errors.yearCf1 = 'Richiesto anno e CF primo socio';
            } else if((!values.yearCf2 && values.cfCollab2) || (values.yearCf2 && !values.cfCollab2)) {
              errors.yearCf2 = 'Richiesto anno e CF secondo socio';
            } else if((!values.yearS3 && values.cfSocio3) || (values.yearS3 && !values.cfSocio3)) {
              errors.yearS3 = 'Richiesto anno e CF terzo socio';
            } else if (!values.year && !values.yearCf1 && !values.yearCf2 && !values.yearS3 && 
              !values.cfImpresa && !values.cfCollab1 && !values.cfCollab2 && !values.cfSocio3) {
              errors.cfImpresa = "Richiesto almeno un codice fiscale da cui scaricare";
            }
            return errors;
          } else {
            if ((!values.year && values.cfImpresa) || (values.year && !values.cfImpresa)) {
              errors.year = 'Richiesto anno e partita iva impresa';
            } else if((!values.yearCf1 && values.cfCollab1) || (values.yearCf1 && !values.cfCollab1)) {
              errors.yearCf1 = 'Richiesto anno e CF primo socio';
            } else if((!values.yearCf2 && values.cfCollab2) || (values.yearCf2 && !values.cfCollab2)) {
              errors.yearCf2 = 'Richiesto anno e CF secondo socio';
            } else if (!values.year && !values.yearCf1 && !values.yearCf2 && 
              !values.cfImpresa && !values.cfCollab1 && !values.cfCollab2 ) {
              errors.cfImpresa = "Richiesto almeno un codice fiscale da cui scaricare";
            }
            return errors;
          }
        }}
        onSubmit={(values, { setSubmitting }) => {
          console.log('submit load');
          if (!values.cfImpresa && !values.cfCollab1 && !values.cfCollab2 && !values.cfSocio3) {
            logger.error('Nessun codice fiscale scelto');
            setSubmitting(false);
            return;
          }
          props.handleSubmitLoadTelematico(values);
          setSubmitting(false);
        }}
      >
        {(formprops: FormikProps<LoadTelematico>) => {
            const { isSubmitting, handleSubmit, values, dirty, submitForm, resetForm, isValid, errors, setFieldValue } = formprops;
          return (
            <Form onSubmit={handleSubmit} translate>
            <DialogContent dividers>
            <div style={{display: 'flex', flexDirection: 'column', flex: '1 1 auto'}}>
              <div style={{display: 'flex', flexDirection: 'row', flex: '1 1 auto'}}>
              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="company" className={classes.label}>Company</InputLabel>
                <Field as={Select}
                    className={classes.select}
                    disabled
                    // value={values.companyId}
                    // onChange={handleChangeSelectCompany}
                    name="companyId"
                    >
                    {companies.map((item: Company, keyIndex: number) => {
                        return (
                        <MenuItem key={keyIndex.toString()} value={item.Id}>
                            {item.BusinessName}
                        </MenuItem>
                        )                    
                    })
                    }
                  </Field>
                </FormControl>
                {/*
                <FormControl className={classes.formControl}>
                  <InputLabel htmlFor="telematicoType" className={classes.label}>Tipo telematico</InputLabel>
                  <Field as={Select}
                    className={classes.select}
                    // value={values.telematicoType}
                    name="telematicoType"
                  >
                    <MenuItem value="PF">Persona fisica</MenuItem>
                    <MenuItem value="SC">Società</MenuItem>
                  </Field>
                </FormControl>
                */}
                <FormControl className={classes.formAutocompleteControl}>
                  {/* <InputLabel htmlFor="agency" className={classes.label}>Studio</InputLabel> */}
                  <Field 
                    component={Autocomplete}
                    className={classes.selectLong}
                    // onChange={handleChangeSelectAgency}
                    defaultValue={values.agency}
                    onChange={(e, value) => setFieldValue("agencyId", value ? value.Id : null)}
                    name="agencyId"
                    options={agencies}
                    getOptionLabel={(option: Agency) => option.Name}
                    renderInput={(params) => <TextField {...params} label="Studio" />}                          
                  />
                </FormControl>
              </div>
              <div style={{display: 'flex', flexDirection: 'row', flex: '0 1 auto', }}>
                <FormControl className={classes.formControl}>
                  <UamNumberField
                    // required
                    // error={error}
                    // helperText={error ? "Campo obbligatorio" : ""}
                    // id="cfImpresa"
                    name="year"
                    label="Anno dichiarativo"
                    fullWidth
                    margin={formTextFieldMargin} 
                    // value={values.cfImpresa}
                    // onChange={handleChangeCfImpresa} 
                    // onBlur={handleBlur}
                    className={gClasses.textField}
                    InputLabelProps={{
                      shrink: true,            
                    }}
                  />
                </FormControl>
                <FormControl className={classes.formControl}>
                  <UamTextField
                    // required
                    // error={error}
                    // helperText={error ? "Campo obbligatorio" : ""}
                    // id="cfImpresa"
                    name="cfImpresa"
                    label="Codice fiscale/Partita Iva"
                    fullWidth
                    margin={formTextFieldMargin} 
                    // value={values.cfImpresa}
                    // onChange={handleChangeCfImpresa} 
                    // onBlur={handleBlur}
                    className={gClasses.textField}
                    InputLabelProps={{
                      shrink: true,            
                    }}
                  />
                </FormControl>
              </div>
              {!isConvenienza && state.famigliare === true && state.quotaCollab1 > 0 ?
              <div style={{display: 'flex', flexDirection: 'row', flex: '1 1 auto'}}>
                <FormControl className={classes.formControl}>
                  <UamNumberField
                    // required
                    // error={error}
                    // helperText={error ? "Campo obbligatorio" : ""}
                    // id="cfImpresa"
                    name="yearCf1"
                    label="Anno dichiarativo"
                    fullWidth
                    margin={formTextFieldMargin} 
                    // value={values.cfImpresa}
                    // onChange={handleChangeCfImpresa} 
                    // onBlur={handleBlur}
                    className={gClasses.textField}
                    InputLabelProps={{
                      shrink: true,            
                    }}
                  />
                </FormControl>
                <FormControl className={classes.formControl}>
                  <UamTextField
                    // required
                    // error={error}
                    // helperText={error ? "Campo obbligatorio" : ""}
                    // id="cfCollab1"
                    name="cfCollab1"
                    label="CF collaboratore 1"
                    fullWidth
                    margin={formTextFieldMargin} 
                    // value={cfCollab1}
                    // onChange={handleChangeCfImpresa} 
                    // onBlur={handleBlur}
                    className={gClasses.textField}
                    InputLabelProps={{
                      shrink: true,            
                    }}
                    // margin="dense"
                  />
                </FormControl>
              </div>
              : isConvenienza ?
              <div style={{display: 'flex', flexDirection: 'row', flex: '1 1 auto'}}>
                <FormControl className={classes.formControl}>
                  <UamNumberField
                    // required
                    // error={error}
                    // helperText={error ? "Campo obbligatorio" : ""}
                    // id="cfImpresa"
                    name="yearCf1"
                    label="Anno dichiarativo"
                    fullWidth
                    margin={formTextFieldMargin} 
                    // value={values.cfImpresa}
                    // onChange={handleChangeCfImpresa} 
                    // onBlur={handleBlur}
                    className={gClasses.textField}
                    InputLabelProps={{
                      shrink: true,            
                    }}
                  />
                </FormControl>
                <FormControl className={classes.formControl}>
                  <UamTextField
                    // required
                    // error={error}
                    // helperText={error ? "Campo obbligatorio" : ""}
                    // id="cfCollab1"
                    name="cfCollab1"
                    label="CF socio 1"
                    fullWidth
                    margin={formTextFieldMargin} 
                    // value={cfCollab1}
                    // onChange={handleChangeCfImpresa} 
                    // onBlur={handleBlur}
                    className={gClasses.textField}
                    InputLabelProps={{
                      shrink: true,            
                    }}
                    // margin="dense"
                  />
                </FormControl>
              </div>
              : null}
              {!isConvenienza && state.famigliare === true && state.quotaCollab2 > 0 ?
              <div style={{display: 'flex', flexDirection: 'row', flex: '1 1 auto'}}>
                <FormControl className={classes.formControl}>
                  <UamNumberField
                    // required
                    // error={error}
                    // helperText={error ? "Campo obbligatorio" : ""}
                    // id="cfImpresa"
                    name="yearCf2"
                    label="Anno dichiarativo"
                    fullWidth
                    margin={formTextFieldMargin} 
                    // value={values.cfImpresa}
                    // onChange={handleChangeCfImpresa} 
                    // onBlur={handleBlur}
                    className={gClasses.textField}
                    InputLabelProps={{
                      shrink: true,            
                    }}
                  />
                </FormControl>
                <FormControl className={classes.formControl}>
                  <UamTextField
                    // required
                    // error={error}
                    // helperText={error ? "Campo obbligatorio" : ""}
                    // id="cfCollab2"
                    name="cfCollab2"
                    label="Cf collaboratore 2"
                    fullWidth
                    margin={formTextFieldMargin} 
                    // value={cfCollab2}
                    // onChange={handleChangeCfImpresa} 
                    // onBlur={handleBlur}
                    className={gClasses.textField}
                    InputLabelProps={{
                      shrink: true,            
                    }}
                    // margin="dense"
                  />
                </FormControl>
              </div>
              : isConvenienza ?
              <div style={{display: 'flex', flexDirection: 'row', flex: '1 1 auto'}}>
              <FormControl className={classes.formControl}>
                <UamNumberField
                  // required
                  // error={error}
                  // helperText={error ? "Campo obbligatorio" : ""}
                  // id="cfImpresa"
                  name="yearCf2"
                  label="Anno dichiarativo"
                  fullWidth
                  margin={formTextFieldMargin} 
                  // value={values.cfImpresa}
                  // onChange={handleChangeCfImpresa} 
                  // onBlur={handleBlur}
                  className={gClasses.textField}
                  InputLabelProps={{
                    shrink: true,            
                  }}
                />
              </FormControl>
              <FormControl className={classes.formControl}>
                <UamTextField
                  // required
                  // error={error}
                  // helperText={error ? "Campo obbligatorio" : ""}
                  // id="cfCollab2"
                  name="cfCollab2"
                  label="Cf socio 2"
                  fullWidth
                  margin={formTextFieldMargin} 
                  // value={cfCollab2}
                  // onChange={handleChangeCfImpresa} 
                  // onBlur={handleBlur}
                  className={gClasses.textField}
                  InputLabelProps={{
                    shrink: true,            
                  }}
                  // margin="dense"
                />
              </FormControl>
            </div>
            : null}                        
            {isConvenienza ? 
              <div style={{display: 'flex', flexDirection: 'row', flex: '1 1 auto'}}>
                <FormControl className={classes.formControl}>
                  <UamNumberField
                    // required
                    // error={error}
                    // helperText={error ? "Campo obbligatorio" : ""}
                    // id="cfImpresa"
                    name="yearS3"
                    label="Anno dichiarativo"
                    fullWidth
                    margin={formTextFieldMargin} 
                    // value={values.cfImpresa}
                    // onChange={handleChangeCfImpresa} 
                    // onBlur={handleBlur}
                    className={gClasses.textField}
                    InputLabelProps={{
                      shrink: true,            
                    }}
                  />
                </FormControl>
                <FormControl className={classes.formControl}>
                  <UamTextField
                    // required
                    // error={error}
                    // helperText={error ? "Campo obbligatorio" : ""}
                    // id="cfCollab1"
                    name="cfSocio3"
                    label="CF socio 3"
                    fullWidth
                    margin={formTextFieldMargin} 
                    // value={cfCollab1}
                    // onChange={handleChangeCfImpresa} 
                    // onBlur={handleBlur}
                    className={gClasses.textField}
                    InputLabelProps={{
                      shrink: true,            
                    }}
                    // margin="dense"
                  />
                </FormControl>
              </div>
              : null
              }
              <div>
                  {!isValid && <ErrorSummaryInModal title='Errori da correggere' errors={errors} schema={telematicoFormSchema} />}
              </div>
            </div>
            </DialogContent>
            <DialogActions>
              <Button disabled={isSubmitting} type="submit">
                  <ImportIcon style={{ width: '2rem', height: '2rem' }} color="primary" titleAccess="Importa" />
              </Button>
              <Button onClick={props.handleClose}>
                  <ExitIcon style={{ width: '2rem', height: '2rem' }} color="secondary" titleAccess="Chiudi" />
              </Button>
            </DialogActions>
          </Form>
          )
        }}
      </Formik>              
    </div>          
  </Dialog>
  );
}
